import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  createSchool,
  updateSchool,
  resetSchoolState,
  fetchSchools,
} from '../store/schoolSlice';
import { fetchAddresses } from '../store/addressSlice';
import { fetchPods } from '../store/podSlice';
import AddressSelector from '../components/AddressSelector';
import PodSelector from '../components/PodSelector';
import SchoolList from '../components/SchoolList';


const NewSchool = () => {
  const dispatch = useDispatch();
  const { success, isLoading, error, schools } = useSelector((state) => state.school);

  const [form, setForm] = useState({
    schoolname: '',
    addressId: '',
    podId: '',
    addressText: '',
    podText: '',
    schoolchainid: '',
    pocname: '',
    pocmobile: '',
    numbeofchildren: 0,
    gradestart: '',
    gradeend: '',
    otherinfo: '',
    isActive: true,
    hasbreakfast: false,
    haslunch: false,
    isbtc: false,
    isbtb: false,
    schoolclass: '',
    section: '',
    isofflinebtb: false,
    schoolarea: '',
    isblockbasedelivery: false,
    isextraboxdelivery: false,
    ibtbbtc: false,
  });

  const [isEditing, setIsEditing] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const checkboxFields = [
    'isActive',
    'hasbreakfast',
    'haslunch',
    'isbtc',
    'isbtb',
    'isofflinebtb',
    'isblockbasedelivery',
    'isextraboxdelivery',
    'ibtbbtc',
  ];

  const formatLabel = (key) =>
    key.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, (str) => str.toUpperCase());

  useEffect(() => {
    dispatch(fetchSchools());
    dispatch(fetchAddresses());
    dispatch(fetchPods());
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      alert(isEditing ? 'School updated!' : 'School created!');
      setForm({
        schoolname: '',
        addressId: '',
        podId: '',
        addressText: '',
        podText: '',
        schoolchainid: '',
        pocname: '',
        pocmobile: '',
        numbeofchildren: 0,
        gradestart: '',
        gradeend: '',
        otherinfo: '',
        isActive: true,
        hasbreakfast: false,
        haslunch: false,
        isbtc: false,
        isbtb: false,
        schoolclass: '',
        section: '',
        isofflinebtb: false,
        schoolarea: '',
        isblockbasedelivery: false,
        isextraboxdelivery: false,
        ibtbbtc: false,
      });
      setIsEditing(false);
      setSelectedId(null);
      dispatch(resetSchoolState());
    }
  }, [success, dispatch, isEditing]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleAddressSelect = (address) => {
    setForm({
      ...form,
      addressId: address.id,
      addressText: `${address.addressline1}, ${address.city}`,
    });
  };

  const handlePodSelect = (pod) => {
    setForm({
      ...form,
      podId: pod.id,
      podText: pod.podname,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = { ...form };
    delete payload.addressText;
    delete payload.podText;

    if (isEditing && selectedId) {
      dispatch(updateSchool({ id: selectedId, formData: payload }));
    } else {
      dispatch(createSchool(payload));
    }
  };

  const handleEdit = (school) => {
    setIsEditing(true);
    setSelectedId(school.id);
  
    const addressText = school.address
      ? `${school.address.addressline1}, ${school.address.city}`
      : '';
    const podText = school.pod?.podname || '';
  
    setForm({
      ...school,
      addressText,
      podText,
    });
  };

  return (
    <div className="space-y-10 px-6">
      <div className="max-w-5xl bg-white rounded shadow p-6 mx-auto space-y-4">
        <h2 className="text-2xl font-bold mb-4">
          {isEditing ? 'Edit School' : 'New School'}
        </h2>
        {error && (
  <p className="text-red-500">
    {error?.error || error?.message || JSON.stringify(error)}
  </p>
)}

        <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
          {/* Checkboxes */}
          <div className="col-span-2 flex flex-wrap gap-6 items-center mb-4">
            {checkboxFields.map((key) => (
              <label
                key={key}
                className="flex items-center gap-2 text-sm font-medium text-gray-700"
              >
                <input
                  type="checkbox"
                  name={key}
                  checked={form[key]}
                  onChange={handleChange}
                />
                {formatLabel(key)}
              </label>
            ))}
          </div>

          <div className="col-span-2">
  <label className="block text-sm font-medium text-gray-600 mb-1">Address</label>
  <div className="flex gap-2">
    <input
      type="text"
      readOnly
      value={
        typeof form.addressText === 'string'
          ? form.addressText
          : `${form.addressText?.addressline1 || ''}, ${form.addressText?.city || ''}`
      }
      className="w-full px-4 py-2 border rounded bg-gray-100 cursor-not-allowed"
    />
    <AddressSelector
      selectedAddress={
        typeof form.addressText === 'string'
          ? { addressline1: form.addressText }
          : form.addressText
      }
      onSelect={(address) =>
        setForm({
          ...form,
          addressId: address.id,
          addressText: `${address.addressline1}, ${address.city}`,
        })
      }
    />
  </div>
</div>

          {/* Pod Selector */}
          <div className="col-span-2">
  <label className="block text-sm font-medium text-gray-600 mb-1">Pod</label>
  <div className="flex gap-2">
    <input
      type="text"
      readOnly
      value={
        typeof form.podText === 'string' ? form.podText : form.podText?.podname || ''
      }
      className="w-full px-4 py-2 border rounded bg-gray-100 cursor-not-allowed"
    />
    <PodSelector
      selectedPod={
        typeof form.podText === 'string' ? { podname: form.podText } : form.podText
      }
      onSelect={(pod) =>
        setForm({
          ...form,
          podId: pod.id,
          podText: pod.podname,
        })
      }
    />
  </div>
</div>
          {/* Remaining text fields */}
          {Object.entries(form).map(([key, value]) => {
const excludedFields = [
  'addressText',
  'podText',
  'addressId',
  'podId',
  'address',   // <- add this
  'pod',       // <- and this
  'createdAt',
  'updatedAt',
  ...checkboxFields,
];

  if (excludedFields.includes(key)) return null;

  return (
    <div key={key} className="col-span-1">
      <label className="block text-sm font-medium text-gray-600 capitalize">
        {formatLabel(key)}
      </label>
      <input
        type="text"
        name={key}
        value={value}
        onChange={handleChange}
        className="w-full px-4 py-2 border rounded"
      />
    </div>
  );
})}


          <div className="col-span-2">
            <button
              type="submit"
              disabled={isLoading}
              className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
            >
              {isLoading ? 'Saving...' : isEditing ? 'Update School' : 'Create School'}
            </button>
          </div>
        </form>
      </div>

      {/* School List */}
      <div className="max-w-5xl bg-white rounded shadow p-6 mx-auto">
        <h2 className="text-xl font-semibold mb-4">Schools</h2>
        <SchoolList schools={schools} onSelect={handleEdit} />

      </div>
    </div>
  );
};

export default NewSchool;
